"use client";
import Image from "next/image";
import React from "react";

const SwipperImage = ({ src, alt, className }) => {
  return (
    <div className={`relative w-full h-0 ${className}`} style={{ paddingBottom: "56.25%" }}>
      <Image
        src={src}
        alt={alt}
        fill
        style={{ objectFit: "contain" }}
        priority
      />
    </div>
  );
};

export default SwipperImage;
